import React, {createContext, useState, useContext, useCallback} from "react";
import { fetchLedger } from "../api/api";
// the api has been removed since the reports are now dynamically generated without need of a backend
// import { useTransactions } from "./TransactionContext";
// import { useAccounts } from "./AccountContext";

const LedgerReportsContext = createContext();

export const useLedgerReports = () => useContext(LedgerReportsContext);

export const LedgerReportsProvider = ({ children }) => {
    const [ledgerTransactions, setLedgerTransactions] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [openingBalanceForPage, setOpeningBalanceForPage] = useState(0);
    // const [cumulativeBalance, setCumulativeBalance] = useState(0);
    const [loading, setLoading] = useState(false);

    const loadLedger = useCallback(async (page = 1, pageSize = 20, filters = {}) => {
        setLoading(true);
        try {
            const data = await fetchLedger(page, pageSize, filters);
            // const isNewFilterSet = page === 1 || Object.keys(filters).length > 0;
            setLedgerTransactions(data.results || []);

            setTotalCount(data.count || 0);

            // always read the new opening balance for the page
            const obVal = parseFloat(data.opening_balance_for_page);
            setOpeningBalanceForPage(obVal);

            setLoading(false);
            return data;
        } catch (error) {
            console.error("Error loading ledger:", error);
            setLoading(false);
            setLedgerTransactions([]);
            setTotalCount(0);
            setOpeningBalanceForPage(0);
            throw error;
        }
   }, []);

    return (
        <LedgerReportsContext.Provider value={{
            ledgerTransactions,
            totalCount,
            openingBalanceForPage,
            loading,
            loadLedger
        }}>
            {children}
        </LedgerReportsContext.Provider>
    );
}